import { exploreResources } from "./TTHTExploreSection.consts";
import { Box } from "@material-ui/core";
import React from "react";
import {
  TTHTSectionContent,
  TTHTSectionTitle,
  TTHTSection,
  TTHTSectionWrapper,
} from "../../../TeachersToolkitHowTo.styled";
import {
  TTHTExploreItemDescription,
  TTHTExploreContentWrapper,
  TTHTExploreItemTitle,
} from "./TTHTExploreSection.styled";

export const TTHTExploreSection = () => (
  <TTHTSection bgcolor="#EDEDED">
    <TTHTSectionWrapper>
      <TTHTSectionContent>
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          textAlign="center"
          marginBottom={1.5}
        >
          <TTHTSectionTitle size="sm">
            Explore our Educational Resources:
          </TTHTSectionTitle>
        </Box>
        <TTHTExploreContentWrapper>
          {exploreResources.map((resource, index) => (
            <Box key={index}>
              <TTHTExploreItemTitle href={resource.href}>
                {resource.name}
              </TTHTExploreItemTitle>
              <TTHTExploreItemDescription>
                {resource.description}
              </TTHTExploreItemDescription>
            </Box>
          ))}
        </TTHTExploreContentWrapper>
      </TTHTSectionContent>
    </TTHTSectionWrapper>
  </TTHTSection>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/Explore/TTHTExploreSection.js